// Cart interaction is delegated to the per-variant <product-card-atc> elements
// rendered inside this card (see product-card-atc.js). This element stays as a
// passive wrapper so the quickview can target it via closest('featured-donation-product').
if (!customElements.get('featured-donation-product')) {
  class FeaturedDonationProduct extends HTMLElement {}
  customElements.define('featured-donation-product', FeaturedDonationProduct);
}
